import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6614fb17 = () => interopDefault(import('../pages/403.vue' /* webpackChunkName: "pages/403" */))
const _11e7088e = () => interopDefault(import('../pages/accounts/index.vue' /* webpackChunkName: "pages/accounts/index" */))
const _5328e278 = () => interopDefault(import('../pages/auth.vue' /* webpackChunkName: "pages/auth" */))
const _6e0ad463 = () => interopDefault(import('../pages/campaign/index.vue' /* webpackChunkName: "pages/campaign/index" */))
const _b37723d6 = () => interopDefault(import('../pages/config/index.vue' /* webpackChunkName: "pages/config/index" */))
const _91b42018 = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _3e60f3a2 = () => interopDefault(import('../pages/home.vue' /* webpackChunkName: "pages/home" */))
const _57062649 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _0eb20822 = () => interopDefault(import('../pages/redeem/index.vue' /* webpackChunkName: "pages/redeem/index" */))
const _c3f43d00 = () => interopDefault(import('../pages/secret.vue' /* webpackChunkName: "pages/secret" */))
const _49fd9f49 = () => interopDefault(import('../pages/config/create.vue' /* webpackChunkName: "pages/config/create" */))
const _96e8dcf8 = () => interopDefault(import('../pages/redeem/detail.vue' /* webpackChunkName: "pages/redeem/detail" */))
const _b6af6e7c = () => interopDefault(import('../pages/config/edit/_id.vue' /* webpackChunkName: "pages/config/edit/_id" */))
const _644dd220 = () => interopDefault(import('../pages/campaign/_code/index.vue' /* webpackChunkName: "pages/campaign/_code/index" */))
const _325e1c86 = () => interopDefault(import('../pages/config/_id.vue' /* webpackChunkName: "pages/config/_id" */))
const _264215a3 = () => interopDefault(import('../pages/campaign/_code/_action.vue' /* webpackChunkName: "pages/campaign/_code/_action" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/403",
    component: _6614fb17,
    name: "403"
  }, {
    path: "/accounts",
    component: _11e7088e,
    name: "accounts"
  }, {
    path: "/auth",
    component: _5328e278,
    name: "auth"
  }, {
    path: "/campaign",
    component: _6e0ad463,
    name: "campaign"
  }, {
    path: "/config",
    component: _b37723d6,
    name: "config"
  }, {
    path: "/dashboard",
    component: _91b42018,
    name: "dashboard"
  }, {
    path: "/home",
    component: _3e60f3a2,
    name: "home"
  }, {
    path: "/login",
    component: _57062649,
    name: "login"
  }, {
    path: "/redeem",
    component: _0eb20822,
    name: "redeem"
  }, {
    path: "/secret",
    component: _c3f43d00,
    name: "secret"
  }, {
    path: "/config/create",
    component: _49fd9f49,
    name: "config-create"
  }, {
    path: "/redeem/detail",
    component: _96e8dcf8,
    name: "redeem-detail"
  }, {
    path: "/config/edit/:id?",
    component: _b6af6e7c,
    name: "config-edit-id"
  }, {
    path: "/campaign/:code",
    component: _644dd220,
    name: "campaign-code"
  }, {
    path: "/config/:id",
    component: _325e1c86,
    name: "config-id"
  }, {
    path: "/campaign/:code/:action",
    component: _264215a3,
    name: "campaign-code-action"
  }, {
    path: "/",
    component: _e542f99c,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
